import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "warningIcon",
  "use": "warningIcon-usage",
  "viewBox": "0 0 2 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 2 10\" id=\"warningIcon\">\n<path d=\"M1.5,9.5h-1C0.2,9.5,0,9.3,0,9V8c0-0.3,0.2-0.5,0.5-0.5h1C1.8,7.5,2,7.7,2,8v1C2,9.3,1.8,9.5,1.5,9.5z M1,5.5\n\tc-0.6,0-1-0.4-1-1v-3c0-0.6,0.4-1,1-1s1,0.4,1,1v3C2,5.1,1.6,5.5,1,5.5z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol